import { Box, Dialog, Typography } from '@mui/material';
import ExoTable from '../exo/ExoTable';
import { useEffect, useState } from 'react';
import { API_GET, DBRequest, useConfig } from '../../api/api';
import { ExoTableToolbar, ExoTableToolbarItem } from '../exo/ExoTableToolbar';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import NewProduct from '../new/NewProduct';
import DBSearch from '../special/DBSearch';
import { useTranslation } from 'react-i18next';
import MoneyLabel from '../label/MoneyLabel';
import Feedback from '../special/Feedback';

const SelectProduct = ({ onSelect, onClose = () => {} }) => {
  const [products, setProducts] = useState({});
  const [productsLoading, setProductsLoading] = useState(true);

  const [searchResults, setSearchResults] = useState(null);

  const { t } = useTranslation();
  const config = useConfig();
  useEffect(() => {
    if (!config) return;
    DBRequest({
      config,
      path: 'products',
      method: API_GET,
      onResponse: setProducts,
      onLoading: setProductsLoading,
    });
  }, [config]);

  function handleSelect(data) {
    DBRequest({
      config,
      path: `products/${data.id}`,
      onResponse: (res) => {
        handleFeedback(
          `${res.data.nr} - ${res.data.name} ${t('added')}`,
          'success'
        );
        onSelect(res.data);
      },
      onLoading: setProductsLoading,
    });
  }

  // table
  const Columns = [
    {
      header: t('Nr'), // header of column
      key: 'nr', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      width: '100px', // width of column
      cell: ({ row }) => <Box className="monospace">{row.nr}</Box>, // custom xml for cells in the column. you get the row as object
      hiddenMobile: true, // hides the column on mobile
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Name'), // header of column
      key: 'label', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      width: 'auto', // width of column
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Price'), // header of column
      key: 'price', // key of column in row-object
      thAlign: 'right', // header text alignment
      tdAlign: 'right', // cell text alignment
      cell: ({ row }) => <MoneyLabel money={row.price} />, // custom xml for cells in the column. you get the row as object
      sortable: true, // enable sort function for column
      width: 'auto', // width of column
      onClick: (row) => handleSelect(row),
    },
  ];

  // new product
  const [open, setOpen] = useState(false);
  function handleNewProductClick() {
    setOpen(!open);
  }

  function handleNewProductCreation(product) {
    var newProducts = { ...products };
    newProducts.data.unshift(product);
    setProducts({ ...newProducts });
  }

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });
  function handleFeedback(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  return (
    <Box className="p-2 h-full w-full flex flex-col">
      <Typography variant="h2" align="center">
        {t('Products')}
      </Typography>
      <ExoTableToolbar>
        <ExoTableToolbarItem
          text={t('New Product')}
          icon={<PlaylistAddIcon />}
          onClick={handleNewProductClick}
        />
      </ExoTableToolbar>
      <DBSearch
        param={'products'}
        onSearch={(res) => setSearchResults({ data: res })}
      >
        <Box className="h-full flex flex-col">
          <ExoTable
            data={searchResults}
            isLoading={productsLoading}
            columns={Columns}
          />
        </Box>
      </DBSearch>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <NewProduct
          onClose={handleNewProductClick}
          onCreate={handleNewProductCreation}
        />
      </Dialog>
      <Feedback
        state={alertState}
        setState={setAlertState}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      />
    </Box>
  );
};

export default SelectProduct;
